import { z } from 'zod';

// The gateway's rule (isStrongPassword): checked here first so a weak
// password never spends a single-use reset link or a captcha token.
// The same symbol set as the gateway's isStrongPassword.
const SYMBOL = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

export const PASSWORD_HINT = 'At least 8 characters, with an uppercase letter, a lowercase letter, a number and a symbol.';
export const strongPassword = z
  .string()
  .min(8, PASSWORD_HINT)
  .refine((p) => /[A-Z]/.test(p) && /[a-z]/.test(p) && /\d/.test(p) && SYMBOL.test(p), PASSWORD_HINT);
